import { Injectable } from '@angular/core'
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { AuthService } from '../services/auth/auth.service'
import { Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly excludedUrls = [
    '/login',
    '/forgot-password',
    '/reset-password',
    'https://places.googleapis.com/v1/places',
    'https://viacep.com.br/ws',
  ]

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.isExcluded(req.url)) {
      return next.handle(req)
    }

    if (!this.authService.isTokenValid()) {
      this.authService.clearToken()
      this.router.navigate(['/login'])
      return throwError(() => new Error('Token inválido ou expirado.'))
    }

    const token = this.authService.getToken()
    const clonedRequest = token
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "69420",
          },
        })
      : req

    return next.handle(clonedRequest).pipe(
      catchError((error) => {
        if (error.status === 401 || error.status === 403) {
          this.authService.clearToken()
          this.dialog.closeAll()
          this.router.navigate(['/login'])
        }
        return throwError(() => error)
      }),
    )
  }

  private isExcluded(url: string): boolean {
    return this.excludedUrls.some((excludedUrl) => url.includes(excludedUrl))
  }
}
